import React from 'react'
import AthleteSearchSummary from '../athletes/AthleteSearchSummary'
import '../layout/Spinner.css'
import '../athletes/AthleteSearchList.css'
import { connect } from 'react-redux'
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import {Link} from 'react-router-dom'
import * as algoliasearch from 'algoliasearch'

const client = algoliasearch('KLMPV6497O', 'e85f94bb57c008e5d960271ed61d0963')
const index = client.initIndex('athletes')

var athleteList = null

const navbarReduxSchoolsIdList = 'navbarSchoolsIdList'

const NavbarSearch = (props) => {

    const filteredSearch = props.filteredSearch
    const isSearching = props.isSearching
    const schools = props.navbarSchoolsIdList

    var athleteSchoolName = null
    var athleteSchoolLogo = null

    if (isSearching) {
    
        index.search(filteredSearch, {
    
            filters: 'NOT profilePublic:false'
    
        }).then(({ hits }) => {

            athleteList = <div className="AthleteSearchListDetail">                        
                                {hits.map(athlete => {

                                    if (schools && athlete.committedSchoolId && athlete.committedSchoolId !== '' &&
                                    athlete.committedSchoolId !== null && athlete.committed) {

                                    const schoolId = athlete.committedSchoolId
                                    athleteSchoolName = schools[schoolId].name
                                    athleteSchoolLogo = schools[schoolId].logo

                                    return (
                                        <Link to={'/athletes/' + athlete.objectID} key={athlete.objectID} onClick={props.navBarSearchClick}>
                                                                            <AthleteSearchSummary athleteSearch={athlete} athleteSchoolName={athleteSchoolName} athleteSchoolLogo={athleteSchoolLogo} key={athlete.objectID}/>
                                                                        </Link>
                                    )
                                    } else {

                                    athleteSchoolName = null
                                    athleteSchoolLogo = null

                                    return (
                                        <Link to={'/athletes/' + athlete.objectID} key={athlete.objectID} onClick={props.navBarSearchClick}>
                                                                            <AthleteSearchSummary athleteSearch={athlete} athleteSchoolName={athleteSchoolName} athleteSchoolLogo={athleteSchoolLogo} key={athlete.objectID}/>
                                                                        </Link>
                                    )
                                    }
                                })}
                            </div>
        })
    
    } else {

        athleteList = null
    }
    
    return (
        athleteList
    )
}

const mapStateToProps = (state) => {

    return {
        navbarSchoolsIdList: state.firestore.data.navbarSchoolsIdList
    }
  }

export default compose(
  connect(mapStateToProps),
    firestoreConnect(() => [
    {
        collection: 'schools',
        storeAs: navbarReduxSchoolsIdList
    }
  ])
)(NavbarSearch)